import { FighterTypeDict, UpdateFighterTypeDto } from "../../../../model/Dto/Dict/FighterType";
import { ApiRequest, RequestMethod } from "../../../request";

export async function updateFighterType(id: string, data: UpdateFighterTypeDto): Promise<FighterTypeDict | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/fighter-type/${id}`);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}
